import { playSound, Sound } from '~/assets/sounds';
import { useLayoutDispatch } from '../../redux/hooks';
import { AuthTabs, setActiveTab } from '../../redux/slices/authTabsSlice';
import { Checkbox } from '../Checkbox';
import { ILoginHints } from './LoginHints.model';
import { StyledContainer } from './LoginHints.styled';

const LoginHints = ({ disabled, onChange }: ILoginHints) => {
	const dispatch = useLayoutDispatch();

	const navigateToRestore = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
	) => {
		event.preventDefault();
		dispatch(setActiveTab(AuthTabs.Restore));
		playSound(Sound.ClickButton);
	};

	return (
		<StyledContainer>
			<Checkbox
				id={'savePwd'}
				disabled={disabled}
				onChange={onChange}
				tabIndex={-1}
				defaultChecked
			/>
			<label htmlFor={'savePwd'}>Автовход</label>
			<span
				onClick={navigateToRestore}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				Забыли пароль?
			</span>
		</StyledContainer>
	);
};

export { LoginHints };
